module.exports = __webpack_public_path__ + "media/video-poster/1080p-25e7fe68.jpg";